import { useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import DropDown from '../../../../components/DropDown';
import { useGetAllCourseListMutation, useGetAllCustomCoursesMutation, useGetClassesMutation } from '../../../../features/authentication/authApiSlice';
import { useGetCourseUsageDatesMutation, useGetDropdownValuesMutation, useUpdateClassIdMutation, useUpdateCourseIdMutation } from '../../../../features/authentication/persistApiSlice';
import '../../styles/reports.css';
import { useNavigate } from 'react-router';
import PropTypes from 'prop-types';
import DatePicker from 'react-datepicker';

const CourseUsageFilter = ({setShowReport,selectedClassId, setSelectedClassId, selectedCourseId,setSelectedCourseId,selectedCustomCourseId
  ,setSelectedCustomCourseId, startDate, setStartDate, endDate, setEndDate, setClassName, setCourseName}) => {

  const navigate = useNavigate();
  const [getAllCourses] = useGetAllCourseListMutation();
  const [getAllClasses] = useGetClassesMutation();
  const [getAllCustomCourses] = useGetAllCustomCoursesMutation();
  const [getDropdownPersistValues] = useGetDropdownValuesMutation();
  const [persistCourseId] = useUpdateCourseIdMutation();
  const [persistClassId] = useUpdateClassIdMutation();
  const [getCourseUsageDates] = useGetCourseUsageDatesMutation();

  const [classes, setClasses] = useState([]);
  const [courses, setCourses] = useState([]);
  const [customCourses, setCustomCourses] = useState([]);

  async function loadClasses()
  {
    var classes = await getAllClasses().unwrap();
    localStorage.setItem('classes', JSON.stringify(classes));

    if(classes.length>0)
    {
      const obj = {
        classID: -1,
        className: 'All Classes'
      };
      const classesArray = [obj, ...classes];
    
      setClasses([
        ...classesArray.map((item) => ({
          name: item.className,
          id: item.classID,
          coteacherName: item.coTeacherClass ? item.teacherName : '',
          coTeacherClass: item.coTeacherClass
        }))
      ]);
    }
  }
  
  const handleClassChange = async (e)=>
  {
    setSelectedClassId(parseInt(e.target.value));
    await persistClassId(parseInt(e.target.value));
  };

  const handleCourseChange = async (e)=>
  {
    setSelectedCourseId(parseInt(e.target.value));
    await persistCourseId(parseInt(e.target.value));
  };

  const handleCustomCourseChange = (e)=>
  {
    setSelectedCustomCourseId(parseInt(e.target.value));
  };

  const handleGenerateReport = ()=>
  {
    if (!selectedCourseId || selectedCourseId == 0 || (selectedCourseId == 255 && (!selectedCustomCourseId))) {
      return;
    }

    if(selectedCourseId == 255) 
    {
      const selectedCourse = customCourses.filter(item=>item.id == selectedCustomCourseId);
      if(selectedCourse.length > 0)
        setCourseName(selectedCourse[0].name);
    }
    else{
      const selectedCourse = courses.filter(item=>item.id == selectedCourseId);
      if(selectedCourse.length > 0)
        setCourseName(selectedCourse[0].name);
    }

    const selectedClass = classes.filter(item=>item.id == selectedClassId);
    if(selectedClass.length>0)
      setClassName(selectedClass[0].name);
    else if(selectedClassId == -1)
      setClassName('All Classes');

    setShowReport(true);
  };
  
  useEffect(()=>{
    const fetchDropDownData = async () => {
      var courses = await getAllCourses().unwrap();
      setCourses(courses);
            
      let classes = localStorage.getItem('classes');
      if (classes) {
        classes = JSON.parse(classes);
        const obj = {
          classID: -1,
          className: 'All Classes'
        };
        const classesArray = [obj, ...classes];

        setClasses([
          ...classesArray.map((item) => ({
            name: item.className,
            id: item.classID,
            coteacherName: item.coTeacherClass ? item.teacherName : '',
            coTeacherClass: item.coTeacherClass
          }))
        ]);
      }else
      {
        loadClasses();
      }

      var customCourses = await getAllCustomCourses().unwrap();
      setCustomCourses(customCourses);
      if(customCourses.length>0)
        setSelectedCustomCourseId(customCourses[0].id);

      var persistDropdownValues = await getDropdownPersistValues().unwrap();
      var persistDates = await getCourseUsageDates().unwrap();
      setSelectedCourseId(persistDropdownValues.courseId);
      setSelectedClassId(persistDropdownValues.classId);
      setStartDate(persistDates.startDate);
      setEndDate(persistDates.endDate);
    };
    
    fetchDropDownData();
  }, []);
    
  return(
    <div>
      <Row className='align-items-center mb-3'>
        <div className="col-md-6">
          <h2 className="primary-title mb-md-0">
            <span className='fw-medium'>Course Usage Report</span>
          </h2>
        </div>
        <div className="col-md-6 d-flex gap-3 flex-column flex-sm-row  justify-content-between justify-content-md-end align-items-center">
          <button
            onClick={() => navigate('/reports')}
            className="btn btn-castleWhite btn-width">
                    Back
          </button>
        </div>
      </Row>
      <Row>
        <Col>
          The Course Usage Report shows how many questions students have answered, with separate counts for assignments and unassigned assignments. You can view a report showing students in one class or students in all of your classes.
        </Col>
      </Row>
      <Row className='mt-4'>
        <Col >
          <DropDown
            key='courseSelect'
            label="Course"
            value={courses}
            onChangeHandler={(e) => handleCourseChange(e)}
            selectedValue={selectedCourseId}
            dropDownName={'Course'}
            tooltipContent ={'Note that the Course selection is used for all tabs except the Class Management tab.'}
          />
                 
        </Col>
        {selectedCourseId === 255 &&  <Col>
          <DropDown
            key='customCourseSelect'
            label="Custom Course"
            value={customCourses}
            onChangeHandler={(e) => handleCustomCourseChange(e)}
            selectedValue={selectedCustomCourseId}
            dropDownName={'CustomCourse'}
          />
        </Col>
        }
        <Col>
          <DropDown
            key='classSelect'
            label="Class"
            value={classes}
            onChangeHandler={(e) => handleClassChange(e)}
            selectedValue={selectedClassId}
            dropDownName={'Class'}
            description={true}
          />
        </Col>
      </Row>
      <Row className='mt-4'>
        <Col><b>Time Period</b></Col>
      </Row>
      <Row className='mt-2'>
        <Col md={3}>
          <label>From</label>
          <div className='date-picker-input p-0'>
            <DatePicker
              selected={startDate}
              onChange={(e) => setStartDate(e)}
              dateFormat={'MM-dd-yyyy'}
              className='form-control'
            />
          </div>
        </Col>
        <Col md={3}>
          <label>To</label>
          <div className='date-picker-input p-0'>
            <DatePicker
              selected={endDate}
              onChange={(e) => setEndDate(e)}
              dateFormat={'MM-dd-yyyy'}
              className='form-control'
            />
          </div>
        </Col>
      </Row>
      <Row>
        <Col className='d-flex justify-content-end'>
          <button className="btn btn-castleRed" onClick={()=> handleGenerateReport()}>
          &nbsp;&nbsp;Create Report&nbsp;&nbsp;
          </button>
        </Col>
      </Row>
    </div>
  );
};

CourseUsageFilter.propTypes={
  setShowReport : PropTypes.func,
  selectedClassId : PropTypes.number,
  setSelectedClassId : PropTypes.func,
  selectedCourseId: PropTypes.number,
  setSelectedCourseId  : PropTypes.func,
  selectedCustomCourseId: PropTypes.number,
  setSelectedCustomCourseId : PropTypes.func,
  startDate: PropTypes.any,
  setStartDate : PropTypes.func,
  endDate: PropTypes.any,
  setEndDate : PropTypes.func,
  setClassName: PropTypes.func,
  setCourseName: PropTypes.func
};

export default CourseUsageFilter;